<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import { provideViewer } from '@dashboard/ui-kit';
import AppShell from './components/app-shell.vue';
import { isResolved, isSignedIn } from './session';
import { createViewer } from './viewer';

const route = useRoute();

/**
 * The viewer is provided here rather than in the shell, so that it sits above
 * `RouterView` and every page is inside it — including a module's, which is
 * the one that cannot reach the session store any other way.
 *
 * Sign-in renders bare below: the shell's nav and sign-out button belong to
 * someone who is already signed in.
 */
provideViewer(createViewer(route, useRouter()));
</script>

<template>
	<!--
		Nothing renders until `/api/me` has answered. The alternative is a
		frame of the signed-out layout for someone who is signed in, which
		reads as having been logged out.
	-->
	<div v-if="!isResolved" class="booting" />

	<RouterView v-else-if="route.meta.anonymous === true || !isSignedIn" />

	<AppShell v-else>
		<RouterView />
	</AppShell>
</template>

<style scoped>
.booting {
	min-height: 100vh;
}
</style>
